class CreateYourCustomBox extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			buttonsSize: '.create-your-custom-box__buttons button',
			checkbox: '.custom-product-card--create-your-custom-box .checkbox',
			productCard: '.custom-product-card--create-your-custom-box',
			summary: '.create-your-custom-box__summary',
			summaryProgress: '.create-your-custom-box__progress',
			addToCartButton: '.summary__buttons button[type="submit"]',
			buttonRemake: '.summary__buton-remake',
			summaryBoxPrice: '.summary__box-price-rendered',
			quantityInput: '[name="quantity"]',
			noticeBoxSizeUpdated: '.create-your-custom-box__notice',
		};

		this.elements = {
			buttonsSize: this.querySelectorAll(this.selectors.buttonsSize),
			checkboxes: this.querySelectorAll(this.selectors.checkbox),
			summary: this.querySelector(this.selectors.summary),
			productCards: this.querySelectorAll(this.selectors.productCard),
			summaryProgress: this.querySelector(this.selectors.summaryProgress),
			addToCartButton: this.querySelector(this.selectors.addToCartButton),
			buttonRemake: this.querySelector(this.selectors.buttonRemake),
			summaryBoxPrice: this.querySelector(this.selectors.summaryBoxPrice),
			quantityInputs: this.querySelectorAll(this.selectors.quantityInput),
			noticeBoxSizeUpdated: this.querySelectorAll(this.selectors.noticeBoxSizeUpdated),
		};

		this.classes = {
			active: 'button--active',
			visible: 'visible',
			hidden: 'hidden',
		};

		this.defaultSelectedBoxSize = '5';
		this.selectedProducts = [];
		this.selectedBoxSize = this.defaultSelectedBoxSize;
		this.selectedBoxSizeVariantId = '';
		this.storageKey = `create-your-custom-box-${new Date().toISOString().split('T')[0]}`;
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.loadFromStorage();
		this.updateButtonsSizeDataset();
		this.initializeVisuals();
		this.addEventListeners();
		this.updateStateAddToCartButton();
	}

	updateButtonsSizeDataset() {
		this.elements.buttonsSize.forEach((button) => {
			const match = button.textContent.match(/\d+/);
			button.dataset.variantSize = match ? match[0] : '1';
		});
	}

	addEventListeners() {
		this.elements.productCards.forEach((productCard) => {
			const checkbox = productCard.querySelector(this.selectors.checkbox);

			if (checkbox) {
				productCard.addEventListener('click', (event) => {
					// Don't trigger checkbox if clicking on quantity selector buttons or inputs
					if (
						event.target.closest('.quantity-selector') ||
						event.target.matches('button.quantity-selector__button') ||
						event.target.matches('.quantity-selector input') ||
						event.target.matches('.quantity-selector button')
					) {
						return;
					}

					this.onCheckboxChange(checkbox, productCard);
				});
			}
		});

		this.elements.checkboxes.forEach((checkbox) => {
			const productCard = checkbox.closest(this.selectors.productCard);
			if (productCard && checkbox) {
				checkbox.addEventListener('change', () => this.onCheckboxChange(checkbox, productCard));
			}
		});

		this.elements.buttonsSize.forEach((button) => {
			button.addEventListener('click', (event) => this.onButtonSizeClick(event));
		});

		this.elements.buttonRemake.addEventListener('click', (event) => this.onButtonRemakeClick(event));

		this.elements.addToCartButton.addEventListener('click', (event) => this.onAddToCartButtonClick(event));

		this.elements.quantityInputs.forEach((input) => {
			input.addEventListener('change', (event) => this.onQuantityChange(event));
			input.addEventListener('input', (event) => this.onQuantityChange(event));
		});
	}

	onQuantityChange(event) {
		const quantityInput = event.target;
		const productCard = quantityInput.closest(this.selectors.productCard);
		const checkbox = productCard.querySelector(this.selectors.checkbox);

		if (checkbox.checked) {
			const newQuantity = parseInt(quantityInput.value);
			if (newQuantity === 0) {
				checkbox.checked = false;
				productCard.classList.remove('custom-product-card--selected');
				this.selectedProducts = this.selectedProducts.filter((product) => product.name !== checkbox.name);
			} else {
				const productIndex = this.selectedProducts.findIndex((product) => product.name === checkbox.name);
				if (productIndex !== -1) {
					this.selectedProducts[productIndex].quantity = newQuantity;
				}
			}

			console.log(this.selectedProducts);

			this.updateSummary();
			this.updateBoxSizeIfNeeded();
			this.saveToStorage();
			this.updateStateAddToCartButton();
		}
	}

	async onAddToCartButtonClick(event) {
		event.preventDefault();

		if (this.elements.addToCartButton.disabled) {
			return;
		}

		const response = await this.addItemToCart(this.selectedBoxSizeVariantId, 1, {
			products: this.selectedProducts.map((product) => `${product.name} - ${product.quantity} buc.`).join(', '),
			_sku: this.selectedProducts.map((product) => `${product.sku} - ${product.quantity} buc.`).join(', '),
		});

		const responseJson = await response.json();

		if (response.ok) {
			if (
				window.themeVariables.settings.cartType === 'page' ||
				window.themeVariables.settings.pageType === 'cart'
			) {
				return (window.location.href = `${Shopify.routes.root}cart`);
			}

			document.dispatchEvent(new CustomEvent('cart:refresh'));

			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) {
				cartDrawer.show();
			} else {
				console.log('No cart drawer found in DOM');
			}

			this.selectedProducts = [];
			this.elements.summary.classList.remove(this.classes.visible);
			this.updateSummary();
			this.saveToStorage();
			this.updateStateAddToCartButton();
			this.deselectAllCheckboxes();
			this.initializeVisuals();
			this.reinitQuantityInputs();
		} else {
			this.dispatchEvent(
				new CustomEvent('cart:error', {
					bubbles: true,
					detail: {
						error: responseJson['description'],
					},
				})
			);

			document.dispatchEvent(new CustomEvent('cart:refresh'));
		}
	}

	reinitQuantityInputs() {
		this.elements.quantityInputs.forEach((input) => {
			input.value = 1;
		});
	}

	onButtonRemakeClick(event) {
		event.preventDefault();
		this.selectedProducts = [];
		this.selectedBoxSize = this.defaultSelectedBoxSize;
		this.saveToStorage();
		this.updateSummary();
		this.updateStateAddToCartButton();
		this.deselectAllCheckboxes();
		this.reinitQuantityInputs();
		this.initializeVisuals();
	}

	deselectAllCheckboxes() {
		this.elements.checkboxes.forEach((checkbox) => {
			checkbox.checked = false;
		});
	}

	async addItemToCart(variantId, quantity, properties = {}) {
		const result = await fetch('/cart/add.json', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				id: variantId,
				quantity: quantity,
				properties: properties,
			}),
		});

		return result;
	}

	onCheckboxChange(checkbox, productCard) {
		checkbox.checked = !checkbox.checked;
		productCard.classList.toggle('custom-product-card--selected', checkbox.checked);

		const quantityInput = productCard.querySelector(this.selectors.quantityInput);
		const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

		if (checkbox.checked) {
			const existingProduct = this.selectedProducts.find((product) => product.name === checkbox.name);

			if (!existingProduct) {
				this.selectedProducts.push({ name: checkbox.name, quantity: quantity, sku: checkbox.dataset.sku });
			}
		} else {
			this.selectedProducts = this.selectedProducts.filter((product) => product.name !== checkbox.name);
		}

		if (this.selectedProducts.length > 0) {
			this.elements.summary.classList.add(this.classes.visible);
		} else {
			this.elements.summary.classList.remove(this.classes.visible);
		}

		this.updateSummary();
		this.updateBoxSizeIfNeeded();
		this.saveToStorage();
		this.updateStateAddToCartButton();
	}

	updateBoxSizeIfNeeded() {
		const selectedCount = this.selectedProducts.reduce((acc, product) => acc + product.quantity, 0);
		const currentBoxSize = parseInt(this.selectedBoxSize);

		// Get all available box sizes sorted from smallest to largest
		const availableSizes = Array.from(this.elements.buttonsSize)
			.map((button) => parseInt(button.dataset.variantSize))
			.sort((a, b) => a - b);

		// Find the optimal box size for the current selection
		const optimalSize = this.findOptimalBoxSize(selectedCount, availableSizes, currentBoxSize);

		// Only update if we found a different optimal size
		if (optimalSize && optimalSize !== currentBoxSize) {
			this.selectedBoxSize = optimalSize.toString();
			this.setBoxSizeActiveButton(this.selectedBoxSize);
			this.updateSummary();
			this.updateStateAddToCartButton();
			this.addANoticeInUiAboutTheNewBoxSize();
		}
	}

	findOptimalBoxSize(selectedCount, availableSizes, currentSize) {
		// If no products selected, use smallest available size
		if (selectedCount === 0) {
			return Math.min(...availableSizes);
		}

		// Find the smallest size that can accommodate all selected products
		const suitableSizes = availableSizes.filter((size) => size >= selectedCount);

		if (suitableSizes.length === 0) {
			// If no size can accommodate, use the largest available
			return Math.max(...availableSizes);
		}

		// Return the smallest suitable size (most cost-effective)
		return Math.min(...suitableSizes);
	}
	addANoticeInUiAboutTheNewBoxSize() {
		console.log(this.elements.noticeBoxSizeUpdated);

		this.elements.noticeBoxSizeUpdated.forEach((notice) => {
			notice.classList.remove(this.classes.hidden);

			setTimeout(() => {
				notice.classList.add(this.classes.hidden);
			}, 4000);
		});
	}

	updateStateAddToCartButton() {
		const addToCartButton = this.querySelector(this.selectors.addToCartButton);
		const selectedCount = this.selectedProducts.reduce((acc, product) => acc + product.quantity, 0);

		if (this.selectedProducts.length > 0 && Number(this.selectedBoxSize) === Number(selectedCount)) {
			addToCartButton.disabled = false;
		} else {
			addToCartButton.disabled = true;
		}
	}

	updateSummary() {
		const selectedCount = this.selectedProducts.reduce((acc, product) => acc + product.quantity, 0);

		this.elements.summaryProgress.textContent = this.elements.summaryProgress.dataset.text
			.replace('[active-number]', selectedCount)
			.replace('[total-number]', this.selectedBoxSize);
	}

	onButtonSizeClick(event) {
		const selectAll = event.target.dataset.selectAll;
		const clickedButton = event.target;
		const variantSize = clickedButton.dataset.variantSize;
		this.setBoxSizeActiveButton(variantSize);

		this.selectedBoxSize = variantSize;

		if (selectAll === 'true') {
			this.elements.checkboxes.forEach((checkbox) => {
				checkbox.checked = false;
				this.onCheckboxChange(checkbox, checkbox.closest(this.selectors.productCard));
			});
		}

		this.updateSummary();
		this.saveToStorage();
		this.updateStateAddToCartButton();
	}

	setBoxSizeActiveButton(variantSize) {
		this.elements.buttonsSize.forEach((button) => {
			button.classList.remove(this.classes.active);
		});

		this.selectedBoxSizeVariantId = document.querySelector(
			`.button[data-variant-size="${variantSize}"]`
		).dataset.variantId;

		const allButtonsWithSameSize = document.querySelectorAll(`[data-variant-size="${variantSize}"]`);
		allButtonsWithSameSize.forEach((button) => {
			button.classList.add(this.classes.active);
		});

		this.selectedBoxPrice = document.querySelector(
			`.button__box-price[data-variant-id="${this.selectedBoxSizeVariantId}"]`
		).innerHTML;
		this.elements.summaryBoxPrice.innerHTML = this.selectedBoxPrice;
	}

	// LocalStorage methods
	saveToStorage() {
		const data = {
			selectedProducts: this.selectedProducts,
			selectedBoxSize: this.selectedBoxSize,
		};

		localStorage.setItem(this.storageKey, JSON.stringify(data));
	}

	loadFromStorage() {
		try {
			const stored = localStorage.getItem(this.storageKey);

			if (stored) {
				const data = JSON.parse(stored);

				this.selectedProducts = data.selectedProducts || [];
				this.selectedBoxSize = data.selectedBoxSize || this.defaultSelectedBoxSize;
			}
		} catch (error) {
			console.error('Error loading from localStorage:', error);
			this.selectedProducts = [];
			this.selectedBoxSize = this.defaultSelectedBoxSize;
		}
	}

	initializeVisuals() {
		// Initialize active button based on selectedBoxSize
		const activeButton = document.querySelector(`[data-variant-size="${this.selectedBoxSize}"]`);

		if (activeButton) {
			this.setBoxSizeActiveButton(this.selectedBoxSize);
		} else {
			this.selectedBoxSize = this.defaultSelectedBoxSize;
			this.setBoxSizeActiveButton(this.selectedBoxSize);
		}

		// Initialize checkboxes and quantities based on selectedProducts
		this.elements.checkboxes.forEach((checkbox) => {
			const selectedProduct = this.selectedProducts.find((product) => product.name === checkbox.name);
			const isSelected = !!selectedProduct;

			checkbox.checked = isSelected;

			const productCard = checkbox.closest(this.selectors.productCard);

			if (productCard) {
				productCard.classList.toggle('custom-product-card--selected', isSelected);

				// Restore quantity from localStorage
				if (selectedProduct) {
					const quantityInput = productCard.querySelector(this.selectors.quantityInput);

					if (quantityInput) {
						quantityInput.value = selectedProduct.quantity;
					}
				} else {
					// Reset quantity to 1 for unselected products
					const quantityInput = productCard.querySelector(this.selectors.quantityInput);

					if (quantityInput) {
						quantityInput.value = 1;
					}
				}
			}
		});

		// Show/hide summary based on selected products
		if (this.selectedProducts.length > 0) {
			this.elements.summary.classList.add(this.classes.visible);
		} else {
			this.elements.summary.classList.remove(this.classes.visible);
		}

		// Update summary display
		this.updateSummary();
		this.updateStateAddToCartButton();
		this.updateBoxSizeIfNeeded();
	}
}

if (!customElements.get('create-your-custom-box')) {
	customElements.define('create-your-custom-box', CreateYourCustomBox);
}
